import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#D8D4CC] bg-[#F7F5F2] mt-32"
    >
      <div className="px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A]">
            Finka <em className="editorial-italic text-[#7B8871]">Wholistic</em>{" "}
            Wellness
          </h3>
          <p className="mt-6 text-[#5C5C59] text-sm leading-relaxed max-w-md">
            A space for the slow, the soft, and the deeply embodied. Wellness
            for the woman returning home to herself.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-eyebrow text-[10px] text-[#5C5C59] mb-5">Visit</p>
          <ul className="space-y-3">
            <li>
              <Link
                to="/booking"
                data-testid="footer-link-book"
                className="text-sm text-[#1A1A1A] hover:text-[#7B8871] transition-colors"
              >
                Book a session
              </Link>
            </li>
            <li>
              <Link
                to="/affirmations"
                data-testid="footer-link-affirmations"
                className="text-sm text-[#1A1A1A] hover:text-[#7B8871] transition-colors"
              >
                Daily affirmations
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                data-testid="footer-link-about"
                className="text-sm text-[#1A1A1A] hover:text-[#7B8871] transition-colors"
              >
                About Finka
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-eyebrow text-[10px] text-[#5C5C59] mb-5">
            Stay close
          </p>
          <div className="flex items-center gap-5 text-[#1A1A1A]">
            <a
              href="mailto:finkawholisticwellness@gmail.com"
              data-testid="footer-email"
              className="flex items-center gap-2 text-sm hover:text-[#7B8871] transition-colors"
            >
              <Mail strokeWidth={1.25} className="w-4 h-4" />
              finkawholisticwellness@gmail.com
            </a>
          </div>
          <div className="mt-4 flex items-center gap-4">
            <a
              href="#"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="text-[#1A1A1A] hover:text-[#7B8871] transition-colors"
            >
              <Instagram strokeWidth={1.25} className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#D8D4CC] px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <p className="font-eyebrow text-[10px] text-[#5C5C59]">
          © {new Date().getFullYear()} Finka Wholistic Wellness
        </p>
        <p className="font-eyebrow text-[10px] text-[#5C5C59]">
          Crafted with stillness
        </p>
      </div>
    </footer>
  );
}
